/** Readonly transaction mode */ const ReadOnly = "readonly";
/** Readwrite transaction mode */ const ReadWrite = "readwrite";
/** Mode for indexedDB transactions */ export const Mode = {
    ReadOnly: ReadOnly,
    ReadWrite: ReadWrite
};
